// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__1bhxm","text":"text__3fvFG","heading":"heading__18pOd","subHeading":"subHeading__2zEtd","container":"container__sDn_b"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/whyCardlessEmi/advantageCard/style.css
// module id = Cmg5
// module chunks = 458